function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, props), React.createElement("g", {
  fill: "none",
  transform: "translate(1 2)"
}, React.createElement("circle", {
  cx: "9",
  cy: "8",
  fill: "#a5b3bb",
  r: "8"
}), React.createElement("path", {
  d: "M5.07 14.97c-1.07-.6-2-1.46-2.7-2.5l6.76-1.43a1.5 1.5 0 01.63 2.93zm-3.9-5.3a7.98 7.98 0 01-.05-3.06l9.7-2.06a1.5 1.5 0 01.63 2.93z",
  fill: "#fff"
}), React.createElement("path", {
  d: "M12.93 1.03c1.07.6 2 1.46 2.7 2.5L9.84 4.74a1.5 1.5 0 11-.62-2.93zm3.9 5.3a8.1 8.1 0 01.05 3.06l-9.7 2.06a1.5 1.5 0 11-.63-2.93z",
  fill: "#0d2b3e"
}))));